// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `hour`
};

const de_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `Stunde`
};

const es_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `hora`
};

const fr_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `heure`
};

const fi_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `tunti`
};

const hi_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `घंटा`
};

const ja_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `時間`
};

const nl_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `uur`
};

const pt_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `hora`
};

const ro_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `oră`
};

const th_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `ชั่วโมง`
};

const ur_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `گھنٹہ`
};

const zh_hant1_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `小時`
};

const da_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `time`
};

const it_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `ora`
};

const vn_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `giờ`
};

const ko_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `시간`
};

const tr_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `saat`
};

const lv_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `stunda`
};

const ar_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `ساعة`
};

const bs_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `sat`
};

const sl_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `ura`
};

const id_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `jam`
};

const sv_widget_time_hour = /** @type {(inputs: {}) => string} */ () => {
	return `timme`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_time_hour = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_time_hour(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_time_hour", locale)
	if (locale === "en") return en_widget_time_hour(inputs)
	if (locale === "de") return de_widget_time_hour(inputs)
	if (locale === "es") return es_widget_time_hour(inputs)
	if (locale === "fr") return fr_widget_time_hour(inputs)
	if (locale === "fi") return fi_widget_time_hour(inputs)
	if (locale === "hi") return hi_widget_time_hour(inputs)
	if (locale === "ja") return ja_widget_time_hour(inputs)
	if (locale === "nl") return nl_widget_time_hour(inputs)
	if (locale === "pt") return pt_widget_time_hour(inputs)
	if (locale === "ro") return ro_widget_time_hour(inputs)
	if (locale === "th") return th_widget_time_hour(inputs)
	if (locale === "ur") return ur_widget_time_hour(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_time_hour(inputs)
	if (locale === "da") return da_widget_time_hour(inputs)
	if (locale === "it") return it_widget_time_hour(inputs)
	if (locale === "vn") return vn_widget_time_hour(inputs)
	if (locale === "ko") return ko_widget_time_hour(inputs)
	if (locale === "tr") return tr_widget_time_hour(inputs)
	if (locale === "lv") return lv_widget_time_hour(inputs)
	if (locale === "ar") return ar_widget_time_hour(inputs)
	if (locale === "bs") return bs_widget_time_hour(inputs)
	if (locale === "sl") return sl_widget_time_hour(inputs)
	if (locale === "id") return id_widget_time_hour(inputs)
	if (locale === "sv") return sv_widget_time_hour(inputs)
	return "widget_time_hour"
};